export const APPROACHES = Object.freeze({
    LIKE: 'like',
    DO_NOT_LIKE: 'do_not_like',
    ALLERGIC: 'allergic',
});

export const TYPES = Object.freeze({
    PRODUCT_TYPE: 'App\\Models\\Product',
    PRODUCT_CATEGORY_TYPE: 'App\\Models\\ProductCategory',
});
